import { useAtsEmployerFeatureApi } from '@/composables/useApi';
import type { EmployerFeature } from '@factoryfixinc/ats-interfaces';
import { useMeStore } from '../me/me.store';
import { InternalError } from '../errors/internal.error';

export class EmployerFeaturePersistence {
  private store = useMeStore();

  public async fetchEmployerFeatures(): Promise<EmployerFeature[]> {
    const employerId = this.store.employer?.id;

    const { data, error, statusCode } = await useAtsEmployerFeatureApi(
      `/employer-features/${employerId}`,
    ).json<EmployerFeature[]>();

    // Carry the numeric status: over HTTP/2 statusText is always empty, so a
    // stringified error would classify a genuine 403 as a transient outage.
    if (error.value || !data.value) {
      throw new InternalError('Could not load employer features', {
        error: error.value,
        status: statusCode.value,
        data: { employerId },
      });
    }

    return data.value;
  }
}
